import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function NewsPreview() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    t
  } = useLanguage();
  const news = [{
    date: '05.03.2026',
    titleKey: 'news.n1.title',
    descKey: 'news.n1.desc',
    gradient: 'from-blue-500/20 to-purple-500/20'
  }, {
    date: '28.02.2026',
    titleKey: 'news.n2.title',
    descKey: 'news.n2.desc',
    gradient: 'from-emerald-500/20 to-teal-500/20'
  }, {
    date: '15.02.2026',
    titleKey: 'news.n3.title',
    descKey: 'news.n3.desc',
    gradient: 'from-orange-500/20 to-red-500/20'
  }];
  return <section id="news" ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-301">
      <div className="relative z-10 mx-auto max-w-7xl" data-id="element-302">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-12 sm:mb-16 flex flex-col sm:flex-row sm:items-end justify-between gap-6" data-id="element-303">
          <div data-id="element-304">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{
            color: 'var(--text-primary)'
          }} data-id="element-305">
              {t('news.title')}
            </h2>
            <p className="text-lg max-w-xl" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-306">
              {t('news.desc')}
            </p>
          </div>
          <button className="inline-flex items-center gap-2 font-medium hover:underline" style={{
          color: 'var(--accent)'
        }} data-id="element-307">
            {t('news.all')} <ArrowRightIcon className="w-4 h-4" data-id="element-308" />
          </button>
        </motion.div>

        <div className="grid gap-6 lg:grid-cols-3" data-id="element-309">
          {news.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1 + index * 0.1
        }} data-id="element-310">
              <article className="h-full rounded-3xl border overflow-hidden flex flex-col transition-all hover:-translate-y-1 hover:shadow-lg" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-secondary)'
          }} data-id="element-311">
                {/* Image Placeholder */}
                <div className={`h-48 w-full bg-gradient-to-br ${item.gradient}`} style={{
              backgroundColor: 'var(--bg-tertiary)'
            }} data-id="element-312" />

                <div className="p-6 sm:p-8 flex flex-col flex-1" data-id="element-313">
                  <time className="text-sm font-medium mb-3" style={{
                color: 'var(--text-muted)'
              }} data-id="element-314">
                    {item.date}
                  </time>
                  <h3 className="text-xl font-bold mb-3 leading-tight" style={{
                color: 'var(--text-primary)'
              }} data-id="element-315">
                    {t(item.titleKey)}
                  </h3>
                  <p className="text-base mb-6 flex-1" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-316">
                    {t(item.descKey)}
                  </p>
                  <a href="#" className="inline-flex items-center gap-2 text-sm font-bold mt-auto" style={{
                color: 'var(--accent)'
              }} data-id="element-317">
                    {t('news.read')} <ArrowRightIcon className="w-4 h-4" data-id="element-318" />
                  </a>
                </div>
              </article>
            </motion.div>)}
        </div>
      </div>
    </section>;
}